import { render } from "./DaftarMonev.vue?vue&type=template&id=467c2984"
import script from "./DaftarMonev.vue?vue&type=script&lang=js"
export * from "./DaftarMonev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__